import styled from 'styled-components';
import { breakpoints } from 'src/styles/theme';
import { VehicleSummaryStyled } from '../VehicleSummaryStyled';
import { rem } from 'polished';

export const VehicleSummaryStyledAC = styled(VehicleSummaryStyled)`
    .benefits-wrapper {
        .benefits {
            background: ${({ theme }) => theme.colors.white};
            border-radius: ${rem(12)};

            @media (max-width: ${breakpoints.xs}px) {
                background: ${({ theme }) => theme.colors.grey6};

                .heading {
                    padding: ${rem('10px')} ${rem('10px')} 0 ${rem('10px')} !important;
                }
            }
            .bullet-points.allow-bullet-points {
                padding-left: ${rem('30px')};
            }
            ul {
                &:not(.allow-bullet-points) {
                    padding-left: ${rem('16px')} !important;
                }
                @media (max-width: ${breakpoints.xs}px) {
                    padding: ${rem('10px')} !important;
                    li {
                        max-width: 98%;
                        list-style: none;
                    }
                }

                svg {
                    circle {
                        fill: ${({ theme }) => theme.colors.grey2};
                        stroke: none;
                    }

                    line {
                        stroke: ${({ theme }) => theme.colors.white};
                        stroke-width: ${rem('3px')};
                    }
                }
            }

            ul,
            .heading {
                padding-left: ${rem('16px')};
                padding-right: ${rem('16px')};
            }

            @media (max-width: ${breakpoints.xs}px) {
                padding: unset;
            }
        }
    }
    span.title {
        font-size: ${rem('16px')};
        font-weight: bold;
        line-height: 1.38;
        color: ${({ theme }) => theme.colors.grey5};
        padding: ${rem('30px')} 0;

        @media (max-width: ${breakpoints.sm}px) {
            display: none;
        }
    }

    .summary-price-container {
        padding-top: ${rem('15.5px')};
        padding-bottom: ${rem('15.5px')};
        border-top: 1px solid #c9c6c5;
        border-bottom: 1px solid #c9c6c5;
        width: 100%;

        @media (max-width: ${breakpoints.sm}px) {
            display: none;
        }

        .catalogPrice,
        .formatMoney {
            font-size: ${({ theme }) => theme.fontSizes.h5};
        }

        .content {
            .header {
                color: ${({ theme }) => theme.colors.grey5};
                .catalog-price-title {
                    border-top: unset;
                    border-bottom: 1px solid #c9c6c5;
                }
            }
        }

        .body {
            .body-wrapper {
                color: ${({ theme }) => theme.colors.grey5};

                .totalMonthlyPriceWrapper {
                    .prefix,
                    .formatMoney {
                        font-size: ${rem('20px')};
                    }
                    .infoIcon {
                        .icon-wrapper {
                            svg {
                                circle {
                                    fill: ${({ theme }) => theme.colors.grey2};
                                    stroke: none;
                                }

                                line {
                                    stroke: ${({ theme }) => theme.colors.white};
                                    stroke-width: ${rem('3px')};
                                }
                            }
                        }
                    }
                }
            }
        }

        .footer {
            font-size: ${({ theme }) => theme.fontSizes.h7} !important;
        }

        .heading-wrapper {
            @media (max-width: ${breakpoints.xs}px) {
                flex-direction: column;

                .price {
                    margin-top: ${rem('15px')};
                }
            }

            .formatMoney {
                font-size: ${rem('20px')};
            }
        }

        .totalMonthlyPriceContainer {
            @media (max-width: ${breakpoints.xs}px) {
                display: flex;
                width: 100%;
                flex-direction: column;
                align-items: flex-start;

                .footer {
                    text-align: left !important;
                }

                .totalMonthlyPriceWrapper .price .or {
                    margin-left: unset;
                }
            }
        }
    }
`;
